import ability from '@/_ability';
import VuexTypes from '@/store/types/index';

const AuthTypes = VuexTypes.auth;
export default {
  [AuthTypes.SET_INFO]: (state, data) => {
    state.roles = data.roles;
    state.user = data.user;

    const permissions = [];

    for (let i = 0; i < data.permissions.length; i++) {
      permissions.push(data.permissions[i].name);
    }

    for (let i = 0; i < data.roles.length; i++) {
      for (let j = 0; j < data.roles[i].permissions.length; j++) {
        if (!permissions.includes(data.roles[i].permissions[j].name)) {
          permissions.push(data.roles[i].permissions[j].name);
        }
      }
    }

    state.permissions = permissions;

    const abilities = [];
    if (data.user['isAdmin']) {
      abilities.push({ subject: 'all', actions: 'manage' });
    } else {
      for (let i = 0; i < state.permissions.length; i++) {
        const [subject, actions] = state.permissions[i].split('.');
        abilities.push({ subject: subject, actions: actions });
      }
    }
    state.abilities = abilities;
    ability.update(abilities);
  },
  [AuthTypes.SET_TOKEN]: (state, token) => {
    state.token = token;
  },
  [AuthTypes.REGISTER]: (state, { data, status }) => {
    state.register = { data, status };
  },
  [AuthTypes.FORGOT_PASSWORD]: (state, { data, status }) => {
    state.forgotPassword = { data, status };
  },
  [AuthTypes.RESET_PASSWORD]: (state, { data, status }) => {
    state.resetPassword = { data, status };
  },
};
